module.exports = __webpack_public_path__ + "img/专属客服.5f2d3287.png";